import { render, staticRenderFns } from "./fcMovie.vue?vue&type=template&id=fd5f8b9e&"
import script from "./fcMovie.vue?vue&type=script&lang=js&"
export * from "./fcMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports